import React, { Component } from 'react';
import Carousel from 'nuka-carousel';
import { connect } from 'react-redux';
import { dotsDecorator } from '../../constants/sliders';
import { isLargeTabletOrSmaller } from '../../core/util/device/screen';
import { Viewport } from '~/components/useViewport';

const mapStateToProps = (state: any) => ({
  viewport: state.runtime.viewport,
});

type TestimonialSliderProps = {
  s?: any;
  viewport: Viewport;
};

class TestimonialSlider extends Component<TestimonialSliderProps> {
  render = () => (
    <Carousel
      cellAlign="center"
      cellSpacing={1000}
      className={this.props.s.peopleSlider}
      dragging
      frameOverflow="hidden"
      renderBottomCenterControls={dotsDecorator}
      renderCenterLeftControls={({ previousSlide, currentSlide }) => {
        let isFirstSlide = currentSlide === 0;
        let controlToReturn = '';
        if (!isLargeTabletOrSmaller(this.props.viewport.width)) {
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
          controlToReturn = (
            <button className={this.props.s.slideController} onClick={previousSlide}>
              <img
                alt="previous slide button"
                className={this.props.s.previousSlide}
                src={
                  isFirstSlide
                    ? 'images/careers/slider-disabled-2@3x.png'
                    : 'images/careers/slider-right-2@3x.png'
                }
              />
            </button>
          );
        }

        return controlToReturn;
      }}
      renderCenterRightControls={({ nextSlide, slideCount, currentSlide }) => {
        let isLastSlide = slideCount === currentSlide + 1;
        let controlToReturn = '';
        if (!isLargeTabletOrSmaller(this.props.viewport.width)) {
          // @ts-expect-error ts-migrate(2322) FIXME: Type 'Element' is not assignable to type 'string'.
          controlToReturn = (
            <button className={this.props.s.slideController} onClick={nextSlide}>
              <img
                alt="next slide button"
                className={this.props.s.nextSlide}
                src={
                  isLastSlide
                    ? 'images/careers/slider-disabled-2@3x.png'
                    : 'images/careers/slider-right-2@3x.png'
                }
              />
            </button>
          );
        }

        return controlToReturn;
      }}
      slidesToShow={1}
      slideWidth={0.95}
      swiping
      width="100%"
    >
      <div className={this.props.s.peopleSlide}>
        <div className={this.props.s.peopleContent}>
          <p>
            “Being an engineer at Solv means coming to work every day with a team that challenges me
            to do my best work. From the first day here, I’ve felt supported to make technical
            decisions that matter, both to me and our customers”
          </p>

          <span className={this.props.s.triangle}>▲</span>
        </div>

        <div className={this.props.s.peopleAuthor}>
          <div className={`${this.props.s.avatar} ${this.props.s.avatar1}`} />

          <p>
            <span>Kamila</span>, Engineering
          </p>
        </div>
      </div>

      <div className={this.props.s.peopleSlide}>
        <div className={this.props.s.peopleContent}>
          <p>
            “Sales at Solv means that you have a direct impact and responsibility to fuel
            much-needed innovation in the healthcare industry - and that you have incredible
            resources and support to get it done.”
          </p>

          <span className={this.props.s.triangle}>▲</span>
        </div>

        <div className={this.props.s.peopleAuthor}>
          <div className={`${this.props.s.avatar} ${this.props.s.avatar2}`} />

          <p>
            <span>Jordan</span>, Sales
          </p>
        </div>
      </div>

      <div className={this.props.s.peopleSlide}>
        <div className={this.props.s.peopleContent}>
          <p>
            “As the voice of the customer at a mission-driven organization, I collaborate daily with
            brilliant, motivated people to build a better future in healthcare.”
          </p>

          <span className={this.props.s.triangle}>▲</span>
        </div>

        <div className={this.props.s.peopleAuthor}>
          <div className={`${this.props.s.avatar} ${this.props.s.avatar3}`} />

          <p>
            <span>Miranda</span>, Customer Success + Operations
          </p>
        </div>
      </div>

      <div className={this.props.s.peopleSlide}>
        <div className={this.props.s.peopleContent}>
          <p>
            “One of the most rewarding things about working at Solv is the team. We have an
            extremely talented and motivated group of people working together toward something we
            all believe in. We’re constantly learning and improving together, and encouraging each
            other to grow and succeed in our own roles.”
          </p>

          <span className={this.props.s.triangle}>▲</span>
        </div>

        <div className={this.props.s.peopleAuthor}>
          <div className={`${this.props.s.avatar} ${this.props.s.avatar4}`} />

          <p>
            <span>Dan</span>, Design
          </p>
        </div>
      </div>
    </Carousel>
  );
}

export default connect(mapStateToProps)(TestimonialSlider);
